import styled, { css } from "styled-components";

export const TableWrapper = styled.div`
  flex: 1;
  min-height: 200px;
  background-color: var(--theme-color-secondary);
  border-radius: 20px;
  overflow-x: auto;
  overflow-y: auto;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);

  @media only screen and (max-width: 600px) {
    background-color: transparent;
    box-shadow: none;
    border-radius: 0;
  }
`;

export const StyledTable = styled.table`
  position: relative;
  width: calc(100% - 0px);
  min-width: 700px;
  border-collapse: collapse;
  margin-bottom: 100px;
  z-index: 1;

  ${props => props.$responsive && css`
    @media only screen and (max-width: 600px) {
      display: none;
    }
  `}
`;

export const StyledThead = styled.thead`
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: var(--theme-color-secondary);

  ${props => props.$offsettop > 0 && `
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  `}
`;

export const StyledTh = styled.th`
  cursor: pointer;
  user-select: none;
  border-left: 1px solid var(--table-border-color);
  border-right: 1px solid var(--table-border-color);
  padding: 14px 16px;
  font-size: 14px;
  text-align: ${(props) => props.$align || 'left'};
  color: var(--text-color-primary);
  min-width: ${(props) => `${props.$minwidth}px` || '100px'};

  ${(props) => props.$sticky && `
    position: sticky;
    ${(props.$sticky === 'right')
      ? `right: 0;`
      : props.$sticky === 'top' ? `top: 0;`
        : props.$sticky === 'bottom' ? `bottom: 0;`
          : `left: 0;`}
    z-index: 100;
    ${(props.$action) && `
      background-image: linear-gradient(to right, transparent, var(--theme-color-secondary), var(--theme-color-secondary));
      @media only screen and (max-width: 600px) {
    min-width: max-content;
  }
    `}
  `}
  
  svg {
    width: 11px;
    height: 11px;
    position: relative;
    left: 5px;
    top: 3px;
    background-color: var(--theme-color-forth);
    color: var(--theme-color-white);
    border-radius: 1em;
    transform: ${(props) => (props.$sortdirection === 'asc' ? 'rotate(-90deg)' : 'rotate(90deg)')};
    transition: all ease-in-out 0.3s;
    padding: 2px;
  }
`;

export const StyledTd = styled.td`
  border: 1px solid var(--table-border-color);
  padding: 8px 16px;
  font-size: 14px;
  text-align: ${(props) => props.$align || 'left'};
  color: var(--text-color-secondary);

  ${(props) => props.$sticky && `
    position: sticky;
    ${(props.$sticky === 'right')
      ? `right: 0;`
      : props.$sticky === 'top' ? `top: 0;`
        : props.$sticky === 'bottom' ? `bottom: 0;`
          : `left: 0;`}
    z-index: ${props.$zindex || 0};
    ${(props.$action) && `
      background-image: linear-gradient(to right, transparent, var(--theme-color-secondary), var(--theme-color-secondary));
    `}
  `}
`;

export const StyledTr = styled.tr`
  background-color: var(--theme-color-secondary);

  &:hover {
    background-color: #bbbbbb15;
  }
`;

export const CardWrapper = styled.div`
  display: none;

  @media only screen and (max-width: 600px) {
    display: block;
  }
`;

export const Card = styled.div`
  background: var(--theme-color-secondary);
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 16px;
  border-left: 3px solid var(--theme-color-primary);
`;

export const CardRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid var(--table-border-color);

  &:last-child {
    border-bottom: none;
  }
`;

export const CardLabel = styled.span`
  color: var(--text-color-primary);
  font-weight: 500;
  font-size: 14px;
  word-break: break-word;
`;

export const CardIcon = styled.div`
  width: 20px;
  height: 20px;
  background-color: var(--theme-color-tertiary);
  border-radius: 100%;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const CardValue = styled.span`
  color: var(--text-color-secondary);
  font-size: 14px;
  text-align: right;
  word-break: break-word;

  p {
    margin: 0;
    word-break: break-word;
  }
`;